import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import mainContentBg from "../../Assets/images/fraudArmorHomeMainBg.jpg";
import infoIconHelp from "../../Assets/images/info_icon_sprite.png";
import blankCheck from "../../Assets/images/blankCheck.png";
import { useTranslation } from "react-i18next";
import { ApplicationState } from "../../../store";
import * as httpClient from "../../../util/httpClient";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";
import { DialogComponent } from "../../../components/common/DialogComponent";
import { useHistory } from "react-router-dom";

const FraudArmor = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );
    const [showAlertDetails, setShowAlertDetails] = useState(false);

    const handleShow = () => {
        setShowAlertDetails(true);
    };

    const handleCloseDialog = (): any => {
        setShowAlertDetails(false);
    };
    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                            .split(";")
                            .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                            .split("=")[1]
                            ? document.cookie
                                .split(";")
                                .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    }, []);

    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            accessCode: "",
            firstLine: "",
            bankAccountNumber: "",
            zipCode: "",
            emailAddress: "",
        },
    });
    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [errorBanner, seterrorBanner] = useState(false);

    const [state, setState] = useState({
        accessCode: "",
        firstLine: "",
        bankAccountNumber: "",
        zipCode: "",
        emailAddress: "",
        showErrorMessage: false,
        errorMsg: "Offer Code is Required",
        isLoading: false,
    });

    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        }
        else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

    const onSubmitForLogin = (data: any) => {
        props.history.push({
            pathname:
                "/Register?Type=" +
                data.provisionalResponseLanding[0].contractStatus +
                "&VALUE=" +
                data.provisionalResponseLanding[0].provisionalID +
                "&GNDNRLL=PSS",
        });
    };

    const getStartSubmit = (data: any) => {
        seterrorBanner(false);
        setState({ ...state, isLoading: true });
        const requestBody = {
            provisionalID: data.accessCode,
            partnerID: partnerID,
        };
        httpClient
            .sendRequest("POST", `api/PssLandingPage/GetPssLandingPage1?enrollFileRequired=true`, requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding.length === 0) {
                    seterrorBanner(true);
                } else if (data.provisionalResponseLanding.length != 0) {
                    props.history.push({
                        pathname:
                            "/Register?Type=" +
                            data.provisionalResponseLanding[0].contractStatus +
                            "&VALUE=" +
                            data.provisionalResponseLanding[0].provisionalID +
                            "&GNDNRLL=PSS",
                    });
                    window.location.reload();
                }
            })
            .catch(function (error) {
                setValue("accessCode", null);
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false, accessCode: "" });
            });
    };

    const SubmitLookup = (data: any) => {
        seterrorBanner(false);
        setState({ ...state, isLoading: true, showErrorMessage: true });
        const requestBody = {
            provisionalID: data.accesscode,
            partnerID: partnerID,
            PersonalizeLine1: data.firstLine,
            CustomerSecret: data.bankAccountNumber,
            zip: data.zipCode,
        };
        httpClient
            .sendRequest("POST", `api/PssLandingPage/GetPssLandingPage5?enrollFileRequired=true`, requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding.length === 0) {
                    seterrorBanner(true);
                } else if (data.provisionalResponseLanding.length != 0) {
                    props.history.push({
                        pathname:
                            "/Register?Type=" +
                            data.provisionalResponseLanding[0].contractStatus +
                            "&VALUE=" +
                            data.provisionalResponseLanding[0].provisionalID +
                            "&GNDNRLL=PSS",
                    });
                    window.location.reload();
                }
            })
            .catch(function (error) {
                setValue("accessCode", null);
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false, accessCode: "" });
            });
    };
    const styles = {
        pssbg: {
            backgroundImage: `url(${mainContentBg})`,
        },
        infoIcons: {
            backgroundImage: `url(${infoIconHelp})`,
        },
    };
    const backToLogin = (e: any) => {
        e.preventDefault();
        var emailValue = state.emailAddress;
        if (emailValue.length) {
            props.history.push({
                pathname: "/Login?Email=" + emailValue,
            })
            window.location.reload();
        } else {
            window.location.href = window.location.origin + '/app/Login';
        }
        
    }
    return (
        <React.Fragment>
            {errorBanner == true ? <PSSBannerMessage layout={"pssfraudAdmor"} showAccessCodeField={errorBanner} setShowAccessCodeField={setShowAccessCodeField} /> : null}
            {/*{state.showErrorMessage ? <PSSBannerMessage layout={"fraudarmorerrormessage"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} /> : null}*/}
            <div className="pss5-main">
                <main is="x3d" id="l-page-content main-content">
                    <div className="row pss5-mobile-content" id="pss-home-header" style={styles.pssbg}>
                        <div className="lookupHeadline">
                            <div className="headline1">I’m New!</div>
                            <div className="headline2"><strong>Please create my online account</strong></div>
                            {showAccessCodeField ? (
                                <div>
                                    <div className="pss5receiptCodeCopy">
                                        Simply enter the access code
                                        <br /> provided to you by a Resolution
                                        <br /> Specialist.
                                    </div>
                                    <div className="pss5receiptCodeCopy1">Simply enter the access code provided to you by a Resolution Specialist.</div>
                                    <form id="form-LookupSubmit" >
                                        <div id="pss5-input-content">
                                            <div className="pss5-input-view">
                                                <strong><label htmlFor="accessCode">Access Code</label></strong>
                                                <input
                                                    aria-required="true"
                                                    className="pss5-input-field"
                                                    type="text"
                                                    id="accessCode"
                                                    name="accessCode"
                                                    onChange={handleInputChange}
                                                    ref={register({
                                                        required: true,
                                                        maxLength: 100,
                                                    })}
                                                />
                                                {errors.accessCode && errors.accessCode.type === "required" && (
                                                    <div role="alert" className="col-xs-12 col-no-gutter">
                                                        <span className="error-msg">Access Code on check is required</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="pss5-form-bottom">
                                            <a href="javascript:void(0)" onClick={() => setShowAccessCodeField(false)}>
                                                Use lookup
                                                <br />
                                                method
                                            </a>
                                            <div>
                                                <button
                                                    id="LookupSubmitButton"
                                                    className="pss5mobileButton getStartedButton"
                                                    onClick={handleSubmit(getStartSubmit)}
                                                >Get Started</button>
                                            </div>
                                            <button className="pss5access-code-link" onClick={() => setShowAccessCodeField(false)}>
                                                Use lookup method
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            ) : (
                                    <form id="form-AccessCode">
                                    <div id="PSS5div" className="pss5Container">
                                        <div id="pss5-input-content">
                                            <div className="pss5-input-view">
                                              <strong>  <label htmlFor="firstLine">
                                                    First Line as it Appears on Your Check
                                                    <div onClick={handleShow} className="info_icon inlineBlock" style={styles.infoIcons}></div>
                                                </label></strong>
                                                <input
                                                    aria-required="true"
                                                    className="pss5-input-field"
                                                    type="text"
                                                    id="firstLine"
                                                    name="firstLine"
                                                    onChange={handleInputChange}
                                                    ref={register({
                                                        required: true,
                                                        maxLength: 100,
                                                    })}
                                                />
                                                {errors.firstLine && errors.firstLine.type === "required" && (
                                                    <div role="alert" className="col-xs-12 col-no-gutter">
                                                        <span className="error-msg fraud-armor-error-msg">First Line on check is required</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div id="pss5-input-content">
                                            <div className="pss5-input-view">
                                               <strong> <label htmlFor="bankAccountNumber">
                                                    Last 4 Digits of Bank Account Number
                                                    <div onClick={handleShow} className="info_icon inlineBlock" style={styles.infoIcons}></div>
                                                </label></strong>
                                                <input
                                                    aria-required="true"
                                                    className="pss5-input-field"
                                                    type="text"
                                                    id="bankAccountNumber"
                                                    name="bankAccountNumber"
                                                        onChange={handleInputChange}
                                                        minLength={1}
                                                        maxLength={4}
                                                        ref={register({
                                                            required: true,

                                                        })}
                                                    />
                                                    {errors.bankAccountNumber && errors.bankAccountNumber.type === "required" && (
                                                    <div role="alert" className="col-xs-12 col-no-gutter">
                                                        <span className="error-msg fraud-armor-error-msg">Last 4 digits of bank account are required</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div id="pss5-input-content">
                                            <div className="pss5-input-view">
                                              <strong>  <label htmlFor="zipCode">
                                                    ZIP Code as it Appears on Your Check
                                                    <div onClick={handleShow} className="info_icon inlineBlock" style={styles.infoIcons}></div>
                                                </label></strong>
                                                <input
                                                    aria-required="true"
                                                    className="pss5-input-field"
                                                    type="text"
                                                    id="zipCode"
                                                    name="zipCode"
                                                    onChange={handleInputChange}
                                                    ref={register({
                                                        required: true,
                                                        maxLength: 100,
                                                    })}
                                                />
                                                {errors.zipCode && errors.zipCode.type === "required" && (
                                                    <div role="alert" className="col-xs-12 col-no-gutter">
                                                        <span className="error-msg fraud-armor-error-msg">ZIP Code is required</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="pss5-form-bottom">
                                         <strong>   <a href="javascript:void(0)" onClick={() => setShowAccessCodeField(true)}>
                                                Enter your
                                                <br />
                                                access code
                                            </a></strong>
                                            <div>
                                                    <button

                                                    id="AccessCodeButton"
                                                        className="pss5mobileButton getStartedButton"
                                                        onClick={handleSubmit(SubmitLookup)}
                                                    >Get Started</button>
                                            </div>
                                            <button className="pss5access-code-link" onClick={() => setShowAccessCodeField(true)}>
                                                Enter your access code
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            )}
                        </div>

                        <div className="loginHeadline">
                            <div className="headline1">I’m Back.</div>
                            <div className="headline2"><strong>Log into my account</strong></div>
                            <form id="form-continue" onSubmit={(e) => { backToLogin(e) } }>
                                <div id="pss5-input-content">
                                    <div className="pss5-input-view">
                                       <strong> <label className="homeLoginShow homeLoginLabels" htmlFor="emailAddress">
                                            Email Address
                                        </label></strong>
                                        <input
                                            /*aria-required="true"*/
                                            className="pss5-input-field"
                                            type="text"
                                            id="emailAddress"
                                            name="emailAddress"
                                            onChange={handleInputChange}
                                        />
                                        {/*{(errors.emailAddress && errors.emailAddress.type === "required") &&*/}
                                        {/*    <div role="alert" className="col-xs-12 col-no-gutter" style={{ marginTop: "10px"}}>*/}
                                        {/*        <span className="error-msg pss-error-msg">Email Address is required</span>*/}
                                        {/*    </div>}*/}
                                    </div>
                                </div>

                                <div className="loginButtonCell">
                                    <a href="" className="closeHomeLogin">
                                        Cancel
                                    </a>
                                    <button
                                        
                                        id=""
                                        className="pss5-continue-button"
                                    >Continue</button>
                                </div>
                            </form>
                            <div className="pss5forgotPassword">
                                <a href="https://www.fraudarmorservice.com/app/forgot-password">Forgot Password?</a>
                            </div>
                        </div>
                    </div>
                </main>
                {showAlertDetails && (
                    <div className="pss-dialog-container">
                        <DialogComponent dialogId="alert-details-dialog" title="" closeDialog={handleCloseDialog}>
                            <img src={blankCheck} role="option" alt="Black Check" style={{ width: "100%" }} />
                        </DialogComponent>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};
export default FraudArmor;
